import { FeberApiClient } from "../../services/commonServices"

export interface IBaseStatistic {
    createdBy: string,
    department: string,
    division: string,
    created?: Date,
}
export interface ISearchedStatistic extends IBaseStatistic {
    keyword: string,
}
export interface IOrderedStatistic extends IBaseStatistic {
    reportGuid: string,
    orderId:string,
    approvedDate?: Date,
}

export interface IDownloadedStatistic extends IBaseStatistic {
    reportGuid: string,
    securityClass?: string,
}

export const insertStatisticData = async (statisticType: StatisticType, data: IDownloadedStatistic | IOrderedStatistic | ISearchedStatistic) => {
    const response = (await FeberApiClient.post("Statistic/Insert", { ...data }, { params: { statisticType: statisticType } })).data;
}

export enum StatisticType {
    Downloaded,
    Searched,
    Ordered,
}